import OrdersApi from '@/API/orders-api'

export default {
  namespaced: true,
  state: {
    selectedBranchId: null,
    colors: [],
    models: [],
    fetched: false,
    loading: false,
  },
  getters: {
    // config(state: any, getters: any, rootState: any, rootGetters: any) {
    //   const currentBranch = rootGetters['auth/user']
    //   return currentBranch?.kitchen_setting?.car_pickup_setting || {}
    // },
    // showCarForm: (state: any) => !!state.config.car,
    config(state: any, getters: any, rootState: any, rootGetters: any) {
      const user = rootGetters['auth/user']

      // find branch by stored branchId
      const branch = user?.branches?.find((b: any) => b.id === state.selectedBranchId)
      return branch?.kitchen_setting?.car_pickup_setting ?? {}
    },

    showCarForm(state: any, getters: any) {
      return !!getters.config.car
    },
  },
  mutations: {
    SET_LOADING(state: any, value: boolean) {
      state.loading = value
    },
    SET_FETCHED(state: any, value: boolean) {
      state.fetched = value
    },
    SET_COLORS(state: any, colors: string[]) {
      state.colors = colors
    },
    SET_MODELS(state: any, models: string[]) {
      state.models = models
    },
    SET_BRANCH_ID(state: any, branchId: any) {
      state.selectedBranchId = branchId
    },
  },
  actions: {
    async getCarOptions({ state, commit }: any, force = false) {
      const hasOptions = (state.models?.length ?? 0) > 0 || (state.colors?.length ?? 0) > 0
      if ((state.loading && !force) || (state.fetched && hasOptions && !force)) {
        return
      }

      commit('SET_LOADING', true)
      try {
        const { colors, models } = await OrdersApi.cars()
        commit('SET_COLORS', colors)
        commit('SET_MODELS', models)
        commit('SET_FETCHED', true)
      } catch (err) {
        console.error(err)
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
}
